export const modelConfigs = [
  {
    'displayName': 'Cat/Dog Detector',
    'backboneName': 'mobilenet224',
    'modelUrl': 'mobilenet224_1_0_oxfordcatdog/model.json',
    'classes': ['dog', 'cat'],
    'preprocessingMode': 'tf',
    'modelSize': '53MB',
    'color': 'red',
    'description': 'A MobileNet224 model trained to detect dogs and cats. it was trained on the Oxford-IIIT Pet Dataset.'
  },
  {
    'displayName': 'COCO',
    'backboneName': 'resnet50',
    'modelSize': '150MB',
    'modelUrl': 'resnet50_coco_best_v2.1.0/model.json',
    'description': 'The pre-trained object detector with a ResNet50 backbone provided by the fizyr team. It detects the 80 classes in the COCO dataset.',
    'classes': [
      'person',
      'bicycle',
      'car',
      'motorcycle',
      'airplane',
      'bus',
      'train',
      'truck',
      'boat',
      'traffic light',
      'fire hydrant',
      'stop sign',
      'parking meter',
      'bench',
      'bird',
      'cat',
      'dog',
      'horse',
      'sheep',
      'cow',
      'elephant',
      'bear',
      'zebra',
      'giraffe',
      'backpack',
      'umbrella',
      'handbag',
      'tie',
      'suitcase',
      'frisbee',
      'skis',
      'snowboard',
      'sports ball',
      'kite',
      'baseball bat',
      'baseball glove',
      'skateboard',
      'surfboard',
      'tennis racket',
      'bottle',
      'wine glass',
      'cup',
      'fork',
      'knife',
      'spoon',
      'bowl',
      'banana',
      'apple',
      'sandwich',
      'orange',
      'broccoli',
      'carrot',
      'hot dog',
      'pizza',
      'donut',
      'cake',
      'chair',
      'couch',
      'potted plant',
      'bed',
      'dining table',
      'toilet',
      'tv',
      'laptop',
      'mouse',
      'remote',
      'keyboard',
      'cell phone',
      'microwave',
      'oven',
      'toaster',
      'sink',
      'refrigerator',
      'book',
      'clock',
      'vase',
      'scissors',
      'teddy bear',
      'hair drier',
      'toothbrush'
    ],
    'preprocessingMode': 'caffe',
    'color': 'green'
  },
  {
    'displayName': 'Purify',
    'backboneName': 'resnet101',
    'modelUrl': 'resnet101_purify/model.json',
    'modelSize': '220MB',
    'description': 'A resnet101 model trained to detect explicit content. It is generously provided by the CTI community team. Their work is also available at https://pury.fi [content warning].',
    'classes': [
      'exposed belly',
      'exposed buttocks',
      'exposed female breast',
      'covered female breast',
      'exposed female genitalia',
      'covered female genitalia',
      'exposed male genitalia',
      'exposed male breast'
    ],
    'preprocessingMode': 'caffe',
    'color': 'blue'
  }
]